'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title", "showCta"];
import PropTypes from 'prop-types';
import I18n from 'I18n';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  children: PropTypes.node,
  showCta: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired
};
const defaultProps = {
  showCta: false
};
const BasePermissionTooltip = props => {
  const {
      title,
      showCta
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  let tooltipTitle = title;
  if (showCta) {
    tooltipTitle = `${title} ${I18n.text('customerDataUiUtilities.PermissionTooltip.cta')}`;
  }
  return /*#__PURE__*/_jsx(UITooltip, Object.assign({}, rest, {
    title: tooltipTitle,
    children: props.children
  }));
};
BasePermissionTooltip.propTypes = propTypes;
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
BasePermissionTooltip.defaultProps = defaultProps;
export default BasePermissionTooltip;